export class TmoLocationLogRecord {

    id: number = 0;
    stage: string = ''
    importfileid : number = 0;
    callid : number = 0;
    msisdn : number = 0;
    rantech : string = '';
    ascertained : Date | null = null;
    active : string = '';
    accuracy : number = 0;
    username : string = '';
    usergroup_val : number = 0;
    usergroup_str : string = '';
    profile : string = '';
    cplongitude : number = 0;
    cplatitude : number = 0;
    cpaltitudeuncertainty : number = 0;
    cpuncertainty : number = 0;
    cpaltitude : number = 0;
    cplatency : number = 0;
    cpstatus_val : number = 0;
    cpstatus_str : string = '';
    cpcgi : string = '';
    cptechnology : string = '';
    cpubp : number = 0;
    neadaddresstype : number = 0;
    neadcounty : string = '';
    neadhousenumber : string = '';
    neadfloor : string = '';
    neadunit : string = '';
    neadroad : string = '';
    neadcity : string = '';
    neadstate : string = '';
    neadpostalcode : string = '';
    tblongitude : number = 0;
    tblatitude : number = 0;
    tbuncertainty : number = 0;
    tbaltitude : number = 0;
    tbaltitudeuncertainty : number = 0;
    tblatency : number = 0;
    tbtechnology : string = '';
    sliraccuracytype : string = '';
    sliraccuracyvalue : number = 0;
    slirlocationtype : string = '';
    triggername : string = '';
    gpsusergroup_val : number = 0;
    gpsusergroup_str : string = '';
    gpsusername : string = '';
    gpslongitude : number = 0;
    gpslatitude : number = 0;
    gpsascertained  : Date | null = null;
    gpsstatic : string = '';
    gpselevation : number = 0;
    gpsspeed : number = 0;
    gpssatellitecount : number = 0;
    gpsstatus : string = '';
    gpsmorphology : string = '';
    gpshdop : number = 0;
    gpspdop : number = 0;
    gpsvdop : number = 0;
}
